const cols = [
  { key: "bancony", label: "Bancony" },
  { key: "inhouse", label: "In-house build" },
  { key: "boost", label: "Boost.ai / Cognigy" },
  { key: "copilot", label: "Copilot Studio" },
  { key: "generic", label: "Generic LLM frameworks" },
];

const rows = [
  {
    label: "Built for banking",
    cells: ["yes", "partial", "no", "no", "no"],
  },
  {
    label: "Open standard, no lock-in",
    cells: ["yes", "yes", "no", "no", "yes"],
  },
  {
    label: "Compliance shipped, not assembled",
    cells: ["yes", "no", "no", "no", "no"],
  },
  {
    label: "On-prem deployment available",
    cells: ["yes", "yes", "no", "partial", "yes"],
  },
  {
    label: "Time to launch",
    cells: ["Weeks", "Quarters", "Weeks", "Weeks", "Weeks"],
  },
];

const renderCell = (val) => {
  if (val === "yes") {
    return (
      <>
        <span className="compare-icon yes" aria-hidden="true">✓</span>
        <span className="compare-text">Yes</span>
      </>
    );
  }
  if (val === "no") {
    return (
      <>
        <span className="compare-icon no" aria-hidden="true">×</span>
        <span className="compare-text">No</span>
      </>
    );
  }
  if (val === "partial") {
    return (
      <>
        <span className="compare-icon partial" aria-hidden="true">•</span>
        <span className="compare-text">Partial</span>
      </>
    );
  }
  return <span className="compare-text">{val}</span>;
};

export const ComparisonTable = () => (
  <section className="section" id="compare">
    <div className="section-inner wide">
      <span className="section-eyebrow">How we compare</span>
      <h2>Where Bancony fits.</h2>
      <p className="lede">
        Five questions worth asking when you're picking how to bring AI into your bank.
        Bancony does well on these, but no tool wins on every dimension, and we'll be
        honest about that on a call.
      </p>

      <div className="compare-wrap" style={{ "--compare-cols": cols.length }}>
        <div className="compare-row head" role="row">
          <div role="columnheader">Capability</div>
          {cols.map((c) => (
            <div key={c.key} role="columnheader">{c.label}</div>
          ))}
        </div>
        {rows.map((r) => (
          <div className="compare-row" key={r.label} role="row">
            <div className="compare-rowlabel" role="rowheader">{r.label}</div>
            {r.cells.map((cell, idx) => (
              <div key={idx} className="compare-cell" data-col={cols[idx].label} role="cell">
                {renderCell(cell)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);
